module.exports = __webpack_public_path__ + "img/wallet.8900d244.svg";